import { consoleLoggerFactory, getDefaultLoggerOptions, type ILogger, LogLevels } from "@/types/console-logger";
const logger: ILogger = consoleLoggerFactory.create( getDefaultLoggerOptions( LogLevels.ERROR ) );

import { DataSyncEvent } from "@/utils/data-sync-event-factory";
import { MessageTypes } from "@/types/enums/message-types";

import { syncSupervisor } from "@/services/data/sync-supervisor";

onmessage = async function( e: MessageEvent< DataSyncEvent > ): Promise< void > {
    try {
        if ( self.indexedDB ) {
            const messageType = e.data.eventType;

            switch ( messageType ) {
                case MessageTypes.REQUEST_SECURE_SYNC:
                    const authToken = e.data.authToken!;
                    const authorizationGrants = e.data.payload!;
                    await syncSupervisor.patchRepositories( authToken, authorizationGrants );

                    postMessage( {
                        eventType: MessageTypes.LOAD_COMPLETE
                    } );
                    break;
            }
        } else {
            logger.error( 'IndexedDB is not supported.' );
        }
    }
    catch ( err ) {
        logger.error( 'An error occurred while attempting to load the persisted data: ', err );
    }
}

export function notifyUpdate( key: string ) {
    postMessage( {
        eventType: MessageTypes.UPDATE_COMPLETE,
        payload: key
    } );
}
